/*
 * @Author: huangzq
 * @Date: 2019-09-27 11:47:59
 * @Last Modified by: huangzq
 * @Last Modified time: 2021-03-05 13:52:58
 * @Desc: 营销资料：（文章、朋友圈、表单、海报）列表中的一块组件-已手动保持一致
*/
<template>
  <div class="mk-data-item">
    <!-- 状态：绝对定位布局 -->
    <!-- 朋友圈状态：已发布(1)、已下线(2) -->
    <!-- 文章、表单、海报状态：未发布(0)、已发布(1)、已下线(2) -->
    <!-- 已发布状态：是不会显示的 -->
    <div
      v-if="itemData.status!==1"
      :class="{'offline-status':itemData.status===2}"
      class="status-wrapper"
    >
      <!-- TODO:后期要删除，官方状态 -->
      <!-- <span v-if="type==='form'&&isOfficialUser">{{ officialStatusMap[itemData.status] }}</span> -->
      <!-- TODO:后期要删除 -->
      <!-- 非官方状态 -->
      <!-- <span>{{ statusMap[itemData.status] }} {{ typeMap[itemData.sourceType] }}</span> -->
    </div>
    <div
      class="status-wrapper"
      :class="{'offline-status':itemData.status===2}"
      :style="{backgroundColor: itemData.status === 1 ? '#60c22f' : '#8c8c8c'}"
    >
      <span>{{ statusMap[itemData.status] }} {{ typeMap[itemData.sourceType] }}</span>
    </div>

    <!-- 封面+操作 -->
    <div
      class="cover-wrapper"
      @mouseenter="onMouseenter"
    >
      <!-- 文章、表单、海报的封面：使用cover字段 -->
      <template v-if="noFriend">
        <!-- 封面 -->
        <mk-image
          :src="itemData.cover"
          fit="cover"
        />
      </template>

      <!-- 朋友圈的封面 -->
      <template v-else>
        <!-- 根据朋友圈的类型：图文、视文、纯文显示不同的封面 -->
        <!-- 视频+文字 -->
        <template v-if="itemData.video">
          <img
            src="~@assets/images/friend_video_text.png"
            class="friend-cover-img"
          />
        </template>
        <!-- 图片+文字 -->
        <template v-else-if="itemData.images&&itemData.images.length">
          <mk-image
            :src="itemData.images[0]"
            fit="cover"
          />
        </template>
        <!-- 纯文字 -->
        <template v-else>
          <img
            src="~@assets/images/friend_text.png"
            class="friend-cover-img"
          />
        </template>
      </template>

      <!-- 操作：绝对定位布局 -->
      <div class="opration-wrapper">
        <!-- 操作栏部分 -->
        <!-- 朋友圈操作：下线、编辑 -->
        <!-- 文章、表单、海报操作：下线、删除、编辑、标签设置 -->
        <div class="op-line">
          <!-- 状态为：1(发布)才显示【下线操作】 -->
          <div
            v-if="itemData.status===1"
            @click="showConfirmDilagFun('offline')"
          >
            下线
          </div>
          <!-- TODO:后期要删除，官方模板的测试状态  -->
          <!-- <div
            v-if="type==='form'&&isOfficialUser&&itemData.status===1"
            @click="showConfirmDilagFun('test')"
          >
            测试
          </div> -->
          <!-- TODO:后期要删除 -->
          <!-- 文章、表单、H5、宣传册：存在 标签设置 -->
          <div
            v-if="isTagSet"
            @click="showSetTagDialog"
          >
            标签设置
          </div>
          <!-- 文章、表单、H5、宣传册(链接访问形式的)：存在 数据 -->
          <div
            v-if="itemData.status && isLinkVisit"
            @click="toData"
          >
            数据
          </div>
          <!-- 都存在 -->
          <div @click="$emit('edit-item')">
            编辑
          </div>
          <!-- 新增的：文章、表单存在 预览 -->
          <div
            v-if="isPreview"
            @click="previewFun"
          >
            预览
          </div>
          <!-- 新增的：文章、表单存在 预览 -->
          <div
            v-if="isPreviewSet"
            @click="previewSetFun"
          >
            预览设置
          </div>
          <!-- 【删除功能】：未发布的都可以删除 -->
          <div
            v-if="itemData.status===0"
            @click="showConfirmDilagFun('delete')"
          >
            删除
          </div>
        </div>
        <!-- 按钮部分 -->
        <div class="btuuon-wrapper">
          <template v-if="noFriend">
            <!-- 文章、表单、H5、宣传册按钮：发布(未发布状态-0)、分享(已发布状态-1)、重新发布(已下线状态-2) -->
            <template v-if="itemData.status===1">
              <div
                v-if="type!=='poster'&&!isMini"
                class="op-button"
                @click="shareFun"
              >
                分享
              </div>
            </template>
            <div
              v-else
              class="op-button"
              @click="showConfirmDilagFun('publish')"
            >
              <!-- TODO:后期要删除，官方模板-重新发布按钮 -->
              <!-- <template v-if="type==='form'&&isOfficialUser">
                重新发布
              </template> -->
              <!-- TODO:后期要删除 -->
              <!-- 非官方模板 -->
              <template>
                {{ itemData.status===2?'重新发布':'发布' }}
              </template>
            </div>
          </template>
          <template v-else>
            <!-- 朋友圈按钮：重新发布(已下线状态-2) -->
            <div
              v-if="itemData.status===2"
              class="op-button"
              @click="showConfirmDilagFun('publish')"
            >
              重新发布
            </div>
          </template>
        </div>
        <!-- 统计部分 -->
        <!-- 朋友圈、海报(非链接访问的)：无 -->
        <!-- 文章、H5、宣传册：pv、uv -->
        <!-- 表单：pv、uv、表单数 -->
        <div
          v-if="isLinkVisit&&itemData.status&&!isMini"
          class="statistics-wrapper"
        >
          <div>累计浏览量（PV）：{{ statistics.pv }}</div>
          <div>累计浏览人数（UV）：{{ statistics.uv }}</div>
          <div v-if="type==='form'">
            表单提交次数：{{ statistics.submit }}
          </div>
        </div>
      </div>

      <!-- 视频的时长展示 -->
      <div
        v-if="type==='video-markting'"
        class="video-duration"
      >
        {{ itemData.duration||'00:00' }}
      </div>
    </div>

    <!-- 标题+二维码icon -->
    <div class="title-icon-wrapper">
      <!-- 标题 -->
      <div class="title ellipsis">
        {{ itemData.title }}
      </div>

      <!-- 朋友圈、海报(非链接访问的)：无 -->
      <!-- 文章、表单、H5、宣传册：有 -->
      <!-- 二维码icon：处于已发布(1)时，才显示 -->
      <template v-if="isLinkVisit">
        <!-- icon 区域 -->
        <div class="icon-wrapper">
          <!-- 小程序icon -->
          <mk-iconfont
            v-if="isMini"
            icon-class="xiaochengxu"
            class="mini-icon"
          />
          <!-- 二维码icon -->
          <div
            v-if="itemData.status===1"
            class="qrcode-icon-wrapper cursor"
          >
            <mk-iconfont
              icon-class="erweima"
              class="qrcode-icon"
            />
            <!-- 二维码图片：绝对定位布局 -->
            <div class="qrcode-img-wrapper">
              <div
                v-if="isMini"
                class="mini-url-wrapper"
              >
                <img
                  :src="siginInMiniCodeUrl"
                  class="miniurl-img"
                  alt="miniurl"
                >
                <mk-button-biz
                  type="primary"
                  width=""
                  font-size="13px"
                  class="downloadSignInMiniCodeImageBtn"
                  @click="downloadSignInMiniCodeImage"
                >
                  下载楼盘签到码
                </mk-button-biz>
                <!-- <form-tab @on-change="handleOnFormTabChange" /> -->
              </div>
              <img
                v-else-if="qrcodeUrl"
                :src="qrcodeUrl"
                class="qrcode-img"
                alt="qrcode-img"
              >
            </div>
          </div>
        </div>
      </template>
      <!-- 海报：下载按钮 -->
      <template v-else-if="type==='poster'">
        <mk-iconfont
          icon-class="xiazai"
          @click.native="downloadPoster"
        />
      </template>
    </div>

    <!-- 当前资料的标签列表：都会显示 -->
    <div class="tag-wrapper">
      <mk-popover
        placement="right"
        trigger="hover"
        popper-class="tag-popper"
      >
        <template slot="reference">
          <div class="tag-item-wrapper cursor">
            <div
              v-for="(tagItem,index) in tagList.slice(0, 3)"
              :key="index"
              class="tag-item"
            >
              {{ tagItem.name }}
            </div>
            <div
              v-if="tagList.length>3"
              class="more-tag"
            >
              <i class="el-icon-more" />
            </div>
          </div>
        </template>
        <div class="tag-item-wrapper">
          <div
            v-for="(tagItem,index) in tagList"
            :key="index"
            class="tag-item"
          >
            {{ tagItem.name }}
          </div>
        </div>
      </mk-popover>
    </div>

    <!-- 确认弹窗 -->
    <!-- 下线确认弹窗：都有 -->
    <!-- 删除确认弹窗：都有 -->
    <!-- 发布确认弹窗：朋友圈的是：重新发布说明，其他的是：发布说明 -->
    <mk-dialog-confirm
      :visible.sync="isShowConfirmDialog"
      v-bind="confirmDialogData"
      append-to-body
      @on-confirm="onConfirm"
    />

    <!-- 标签设置弹窗：朋友圈、小程序类型不会显示 -->
    <template v-if="noFriend&&!isMini">
      <set-tag-rules-drawer
        :visible.sync="isShowSetTagDialog"
        :dialog-data="setTagDialogData"
        :type="type"
        :is-all-reprint="itemData.sourceType === 4"
        @on-confirm="tagDialogConfirmFun"
      />
    </template>

    <!-- 分享弹窗：非链接访问的、小程序类型不会显示 -->
    <template v-if="isLinkVisit&&!isMini">
      <share-dialog
        :visible.sync="isShowShareDialog"
        :dialog-data="shareDialogData"
      />
    </template>

    <!-- 文章、案例、表单预览弹窗 -->
    <previewAndMsgDialog
      v-if="isShowPreviewAndMsgDialog"
      :link-url="shareDialogData.linkUrl"
      :msg-data="itemData"
      :reprint-url="reprintUrl"
      :is-mini="isMini"
      @on-change="handleOnPreviewMsgChange"
      @close="isShowPreviewAndMsgDialog=false"
    />

    <!-- 下载海报类型选择弹窗 -->
    <download-poster-type
      v-if="type==='poster'"
      :visible.sync="isShowDownloadPosterTypeDialog"
      :dialog-data="itemData"
    />
  </div>
</template>

<script>
// lodash节流函数
import { throttle } from 'lodash'

import setTagRulesDrawer from '@components/set-tag-rules-drawer'

import shareDialog from './share-dialog'

import previewAndMsgDialog from './previewAndMsgDialog/index'
// import FormTab from './previewAndMsgDialog/form-tab.vue'

import downloadPosterType from '../poster-tab/download-poster-type'

export default {
  name: 'Item',
  components: {
    setTagRulesDrawer,
    shareDialog,
    previewAndMsgDialog,
    // FormTab,
    downloadPosterType
  },
  props: {
    // * 当前item的数据
    itemData: {
      type: Object,
      default () {
        return null
      }
    },
    // * 当前item的类型：article(文章)、circleFriends(朋友圈)、form(表单)、poster(海报)、h5(H5)、brochure(宣传册)
    type: {
      type: String,
      default: ''
    },
    // 其他接口promise：发布、删除、查询等
    otherApi: {
      type: Object,
      default () {
        return {}
      }
    },
    // 其他接口promise：发布、删除、查询等（小程序版本）
    otherMiniApi: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      // 转载或原创
      typeMap: {
        1: '原创',
        2: '转载',
        4: '转载'
      },
      // * 通用状态map
      statusMap: {
        0: '未发布',
        1: '已发布',
        2: '已下线' // 测试
      },
      // TODO:后期要删除，官方状态map
      officialStatusMap: {
        0: '已下线',
        1: '已发布',
        2: '已测试'
      },
      // TODO:后期要删除

      // * pv、uv等统计数据
      statistics: {
        pv: 0,
        uv: 0,
        submit: 0
      },

      // * 二维码图片路径
      qrcodeUrl: '',

      // * 是否显示【确认弹窗】
      isShowConfirmDialog: false,

      // * 【确认弹窗】数据
      confirmDialogData: {},

      // * 当前【确认弹窗】类型：删除(delete)、下线(offline)、发布(publish)、TODO:后期要删除，测试(test 官方账户)
      confirmDialogType: 'delete',

      // * 是否显示【分享弹窗】
      isShowShareDialog: false,

      // * 【分享弹窗】数据
      shareDialogData: {
        title: '',
        linkUrl: '',
        qrcodeUrl: ''
      },

      // * 是否显示【标签设置弹窗】
      isShowSetTagDialog: false,
      // * 【设置标签弹窗】数据
      setTagDialogData: { title: '' },

      // TODO:后期要删除，是否为官方账户
      isOfficialUser: false,
      // TODO:后期要删除

      // * 文章预览弹窗是否显示
      isShowPreviewAndMsgDialog: false,
      // * 转载文章的链接
      reprintUrl: '',

      // * 是否显示下载海报类型选择弹窗
      isShowDownloadPosterTypeDialog: false,

      // * 当前小程序表单预览子类
      miniFormChildrenType: 'signIn',
      // 确认弹窗-里面的确认按钮loading
      dialogConfirmButtonLoading: null

    }
  },
  computed: {
    // * 当前类型不是朋友圈
    noFriend () {
      return this.type !== 'circleFriends'
    },

    // * 当前类型对应的H5访问形式是否为链接
    // * 当为true时：则需要生成二维码地址、显示分享弹窗等，用于查看链接
    isLinkVisit () {
      // * 当前的所有类型：article(文章)、circleFriends(朋友圈)、form(表单)、poster(海报)、h5(H5)、brochure(宣传册)
      // * 链接访问的类型：article, form, h5、brochure
      // * 链接访问的类型：article, form, h5
      const isLinkVisitList = ['article', 'form', 'h5', 'brochure', 'case', 'video-markting']
      return isLinkVisitList.includes(this.type)
    },

    // * 有效的标签数据，过滤掉name为空的
    tagList () {
      if (Array.isArray(this.itemData.showTags)) {
        return this.itemData.showTags.filter(item => {
          return item.name
        })
      } else return []
    },

    // 是否需要标签设置
    isTagSet () {
      // 小程序不要
      // 文章、案例、表单需要
      return !this.isMini && ['article', 'case', 'form', 'video-markting'].includes(this.type)
    },

    // 是否需要【预览】
    isPreview () {
      // 文章、案例、表单、营销视频需要
      return ['article', 'case', 'form', 'video-markting'].includes(this.type)
    },

    // 是否需要【预览&设置】
    isPreviewSet () {
      // 海报、H5、宣传册需要
      return ['poster', 'h5', 'brochure'].includes(this.type)
    },

    // * 是否为小程序模板
    isMini () {
      return this.itemData.industry === 'estate'
    },

    // 正式的【楼盘签到】小程序码
    siginInMiniCodeUrl () {
      const { childFormAttr } = this.itemData

      // 小程序表单对应的二级表单分类列表
      const miniFormChildrenList = [
        {
          name: '外派驻点',
          code: 'station', // 前端定义的值，用于前端交互的
          value: 1 // 后端定义的值，用于后端交互的
        }, {
          name: '楼盘签到',
          code: 'signIn',
          value: 2
        }
      ]

      const { value } = miniFormChildrenList.find(({ code }) => code === this.miniFormChildrenType)

      const { signCodeUrl } = childFormAttr.find(({ childFormType }) => childFormType === value)

      return signCodeUrl
    }
  },
  created () {
    // TODO:后期要删除
    // 是否为官方账户
    this.isOfficialUser = this.$isOfficialAccount()
    // TODO:后期要删除

    if (this.isLinkVisit) {
      // * 根据访问地址生成图片二维码
      this.createQrcodeUrl()
    }
  },
  methods: {
    // * 根据访问地址生成图片二维码
    async createQrcodeUrl () {
      const { linkUrl, qrcodeUrl } = this.util.createH5Url(
        this.itemData,
        this.type,
        this.$projectScene,
        true,
        { isMini: this.isMini }
      )

      this.shareDialogData.title = this.itemData.title
      this.shareDialogData.linkUrl = linkUrl
      if (!this.isMini) {
        // 当不为小程序表单时，才生成H5二维码
        this.qrcodeUrl = await this.$createQrcode(qrcodeUrl)
        this.shareDialogData.qrcodeUrl = this.qrcodeUrl
      }
    },

    // * 移入封面，调用统计数据接口，使用了lodash的节流函数来处理
    onMouseenter: throttle(
      function () {
        if (this.isLinkVisit && this.itemData.status && !this.isMini) {
          this.statisticsApi()
        }
      },
      2000,
      {
        trailing: false
      }
    ),

    /**
     * * 调用接口，获取pv、uv；ps(朋友圈、海报等非链接访问的不会调用)
     */
    async statisticsApi () {
      const res = await this.otherApi.statistics(
        {
          _id: this.itemData._id
        }
      )
      if (res.success) {
        this.statistics = res.data
      }
    },

    /**
     * * 数据操作：跳转到数据页面，带上Id
     */
    toData () {
      if (this.isMini) {
        // 当为小程序是跳转到这个数据页面去
        this.$router.push({
          path: '/marketing-content/marketing-data/real-estate-data',
          query: {
            title: this.itemData.title,
            id: this.itemData._id,
            type: this.type,
            buildId: this.itemData.buildId
          }
        })
        return
      }

      this.$router.push({
        path: '/marketing-content/marketing-data/statistical-data',
        query: {
          title: this.itemData.title,
          id: this.itemData._id,
          type: this.type
        }
      })
    },

    /**
     * * 预览事件：预览文章、表单
     */
    async previewFun () {
      if (this.itemData.sourceType === 4) {
        // 当为 任意转载文章时，需要从接口获取原网址
        const res = await MKMATERIALSVC.ArticleApi.articleFindOneGet({
          _id: this.itemData._id
        })
        if (res.success) {
          this.reprintUrl = res.data.originalUrl
          this.isShowPreviewAndMsgDialog = true
        }
      } else {
        this.reprintUrl = ''
        this.isShowPreviewAndMsgDialog = true
      }
    },

    // 预览&设置按钮事件
    previewSetFun () {
      this.$emit('on-preview-set', this.itemData)
    },

    /**
     * * 根据type，显示不同种类的【确认弹窗】
     */
    showConfirmDilagFun (confirmDialogType) {
      if (confirmDialogType === 'publish') {
        // * 【发布确认弹窗】
        this.confirmDialogData = {
          title: '确定要发布这条信息吗？',
          tip: '该作品尚未发布，发布后可进行分享，是否发布？',
          iconColor: '#FAAD14',
          iconClass: 'guanbihuojingshihuocuowu',
          closeBtn: {
            type: 'default',
            color: '#595959',
            text: '取 消',
            isShow: true
          },
          confirmBtn: {
            type: 'primary',
            color: '#fff',
            text: '发 布',
            isShow: true
          }
        }
        if (!this.noFriend) {
          // 朋友圈只有：重新发布弹窗
          this.confirmDialogData.title = '重新发布'
          this.confirmDialogData.tip =
            '重新发布后，员工可查看并分享此朋友圈素材。'
        }
      } else {
        if (confirmDialogType === 'offline') {
          // * 【下线确认弹窗】
          this.confirmDialogData = {
            title: '确认要下线此内容吗？',
            tip: '下线后此内容无法访问'
          }
        } else if (confirmDialogType === 'test') {
          // TODO:后期要删除，测试(官方账户)【测试确认弹窗】
          this.confirmDialogData = {
            title: '确认要此内容改为测试状态吗',
            tip: '测试状态时此内容无法访问'
          }
          // TODO:后期要删除
        } else {
          // * 【删除确认弹窗】
          this.confirmDialogData = {
            title: '确认要删除此内容吗',
            tip: '删除后无法恢复，是否删除？'
          }
        }
      }

      this.isShowConfirmDialog = true
      this.confirmDialogType = confirmDialogType
    },

    /**
     * * 【确认弹窗】点击确认时，调用的方法
     */
    onConfirm () {
      if (this.confirmDialogType === 'delete') {
        // 删除
        this.deleteApi()
      } else {
        // 改变状态：下线、发布、重新发布都走这个接口
        this.releaseApi()
      }
    },

    /**
     * * 删除方法：调用【删除】接口
     */
    async deleteApi () {
      const { _id } = this.itemData
      let params = { _id }
      if (this.type === 'form') params = { ids: [_id] }

      let apiPromise = this.otherApi.delete
      if (this.isMini) {
        apiPromise = this.otherMiniApi.delete
      }

      const res = await apiPromise(params)
      if (res.success) {
        this.$message({
          type: 'success',
          message: '删除成功！'
        })
        // 删除成功，调用父组件的delete-item
        this.$emit('delete-item')
      }
    },

    /**
     * * 更新文章发布状态--未发布/发布/下线
     * @param status：0(未发布)、1(发布)、2(下线)
     */
    async releaseApi () {
      let status = 2
      let message = '下线'
      if (this.confirmDialogType === 'publish') {
        if (this.dialogConfirmButtonLoading) {
          console.log(`正在发布中`)
          return
        }

        this.dialogConfirmButtonLoading = this.$loading({
          target: '.mk-dialog-confirm .el-button--primary',
          customClass: 'mk-dialog-confirm-button-loading'
        })

        status = 1
        message = '发布'
      }

      let params = { ...this.itemData, status }
      if (this.type === 'form') {
        // TODO:后期要删除，官方模板账户，执行发布、下线时，会操作官方模板的状态
        if (this.isOfficialUser) {
          // if (this.confirmDialogType === 'offline') {
          //   status = 0
          // }
          // if (this.confirmDialogType === 'test') {
          //   message = '测试'
          // }
          params.officialStatus = status
        }
        // TODO:后期要删除
      }

      let apiPromise = this.otherApi.publish
      if (this.isMini) {
        params = { status, _id: this.itemData._id }
        apiPromise = this.otherMiniApi.publish
      }

      const res = await apiPromise(params)
      if (res.success) {
        if (this.dialogConfirmButtonLoading) {
          this.dialogConfirmButtonLoading.close()
          this.dialogConfirmButtonLoading = null
        }

        this.$message({
          type: 'success',
          message: message + '成功！'
        })
        let emitData = { status }
        if (this.isMini) {
          emitData = { _id: this.itemData._id, isMini: true }
        }
        // 【发布、下线】成功，调用父组件的update-item
        this.$emit('update-item', emitData)
      }
    },

    /**
     * * 分享方法：显示【分享】弹窗
     */
    shareFun () {
      this.isShowShareDialog = true
    },

    // 小程序表单-小程序码切换操作
    handleOnFormTabChange (code) {
      this.miniFormChildrenType = code
    },

    /**
     * * 标签设置：显示【标签设置弹窗】
     */
    showSetTagDialog () {
      this.setTagDialogData.title = this.itemData.title
      this.setTagDialogData.key = Number(new Date().getTime())

      const { rules } = this._.cloneDeep(this.itemData)
      this.setTagDialogData.rules = rules

      this.isShowSetTagDialog = true
    },

    /**
     * * 【设置标签弹窗】-点击保存事件：将最新的标签更新到数据库
     */
    async tagDialogConfirmFun () {
      const { _id, status } = this.itemData

      let apiPromise = this.otherApi.update
      if (this.isMini) {
        apiPromise = this.otherMiniApi.update
      }

      // 设置时需全量更新
      const res = await apiPromise({
        ...this.itemData,
        _id,
        status,
        // tags: this.setTagDialogData.tagIdList
        rules: this.setTagDialogData.rules
      })
      if (res.success) {
        this.isShowSetTagDialog = false
        this.$message({
          type: 'success',
          message: '修改成功！'
        })
        // 【更新标签】成功，调用父组件的update-item
        this.$emit('update-item', { _id })
      }
    },

    // 显示下载海报类型选择弹窗
    downloadPoster () {
      this.isShowDownloadPosterTypeDialog = true
    },

    // 预览消息弹窗-切换事件
    handleOnPreviewMsgChange ({ linkUrl }) {
      this.shareDialogData.linkUrl = linkUrl
    },

    // * 下载楼盘签到的正式小程序码
    downloadSignInMiniCodeImage () {
      this.util.downloadImage({
        title: this.itemData.title + '-楼盘签到码',
        href: this.siginInMiniCodeUrl,
        type: 'png'
      })
    }
  }
}
</script>

<style lang='scss' >
body {
  .mk-data-item {
    position: relative;
    width: 262px;
    height: 346px;
    background-color: #fefefe;
    border: 1px solid #e8e8e8;
    box-sizing: border-box;
    transition: box-shadow 0.5s linear;

    &:hover {
      box-shadow: 0 4px 10px 4px rgba(0, 0, 0, 0.1);
    }

    // * 状态：绝对定位的
    .status-wrapper {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      // width: 99px;
      padding-right: 12px;
      height: 28px;
      color: #fefefe;
      font-size: 13px;
      line-height: 28px;
      text-indent: 17px;
      background-color: #60c22f;
      border-radius: 0 0 0 54px;
    }

    .offline-status {
      background-color: #8c8c8c;
    }

    // * 封面+操作
    .cover-wrapper {
      position: relative;
      height: 260px;
      overflow: hidden;

      &:hover {
        .opration-wrapper {
          opacity: 1;
          z-index: 1;
        }
      }

      // * 封面
      .mk-image,
      .friend-cover-img {
        width: 100%;
        height: 100%;
      }

      // * 操作：绝对定位的；下线、删除、标签管理等等
      .opration-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        width: 260px;
        height: 260px;
        padding: 10px 10px 30px;
        box-sizing: border-box;
        background-color: rgba(0, 0, 0, 0.7);
        color: #fefefe;
        opacity: 0;
        transition: opacity 0.5s linear;

        // * 操作栏：下线、删除、标签管理等
        .op-line {
          display: flex;
          align-items: center;
          flex-wrap: wrap;

          & > div {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 24px;
            padding: 0 5px;
            margin-right: 10px;
            margin-bottom: 10px;
            font-size: 13px;
            border-radius: 2px;
            border: 1px solid #fff;
            box-sizing: border-box;
            transition: all 0.3s;

            @extend .cursor;

            &:hover {
              border-color: #009cff;
              background-color: #009cff;
            }
          }
        }

        // * 按钮：发布、分享等
        .btuuon-wrapper {
          position: absolute;
          top: 114px;
          left: 75px;

          .op-button {
            width: 108px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            font-size: 14px;
            background-color: rgba(254, 254, 254, 0.2);
            border-radius: 20px;
            border: 1px solid #fefefe;

            @extend .cursor;

            &:hover {
              background-color: #009cff;
              border-color: #009cff;
            }
          }
        }

        // * 统计：pv、uv
        .statistics-wrapper {
          font-size: 12px;
          line-height: 22px;
          text-align: center;
        }
      }

      // 视频时长
      .video-duration {
        position: absolute;
        right: 10px;
        bottom: 10px;
        color: #fff;
        font-size: 13px;
        text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
      }
    }

    // 标题+标签

    .title-icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 44px;
      padding: 0 10px;
      font-size: 14px;

      .mini-icon {
        padding-left: 10px;
        font-size: 14px;
        color: #15ad31;
      }

      .icon-wrapper {
        display: flex;
        align-items: center;
        height: 44px;

        .qrcode-icon-wrapper {
          display: flex;
          align-items: center;
          height: 100%;
          padding-left: 10px;

          &:hover {
            .qrcode-img-wrapper {
              opacity: 1;
              z-index: 10;
            }
          }

          // 二维码icon
          .qrcode-icon {
            font-size: 14px;
            color: #8c8c8c;
          }

          // 二维码图片：绝对定位的
          .qrcode-img-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            left: 0;
            width: 260px;
            height: 260px;
            background-color: #fff;
            border-bottom: 1px solid #e8e8e8;
            opacity: 0; //0，1
            z-index: -1; //-1，10
            // transition: opacity 0.3s;
            box-sizing: border-box;

            .qrcode-img {
              width: 142px;
            }

            .mini-url-wrapper {
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              height: 100%;
              width: 100%;

              .miniurl-img {
                width: 120px;
              }

              .downloadSignInMiniCodeImageBtn {
                position: absolute;
                bottom: 16px;
              }
            }
          }
        }
      }

      .icon-mk-xiazai {
        color: #8c8c8c;
        padding: 10px 0 10px 10px;

        @extend .cursor;
      }
    }

    .tag-wrapper {
      .tag-item-wrapper {
        display: flex;
        align-items: center;
        margin: 0 10px;

        &:hover {
          .more-tag {
            background-color: #e6efff;
            border: 1px solid #d5e3ff;

            .el-icon-more {
              color: #4e78f0;
            }
          }
        }

        .tag-item {
          height: 22px;
          padding: 0 8px;
          margin-right: 8px;
          line-height: 22px;
          background-color: #ebeff4;
          border-radius: 2px;
          color: #6b7b88;
          font-size: 12px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:last-child {
            margin-right: 0;
          }
        }

        .more-tag {
          flex: none;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 25px;
          height: 22px;
          text-align: center;
          border-radius: 2px;
          border: 1px solid transparent;
          transition: all 0.3s;

          .el-icon-more {
            font-size: 12px;
            color: #767676;
          }
        }
      }
    }
  }

  .tag-popper {
    min-width: unset;
    padding: 10px 0 0 10px;

    .tag-item-wrapper {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 145px;
      max-height: 300px;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 5px;
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: rgba(193, 193, 193, 0.8);
      }

      .tag-item {
        height: 22px;
        padding: 0 8px;
        margin-right: 10px;
        margin-bottom: 10px;
        line-height: 22px;
        background-color: #ebeff4;
        color: #6b7b88;
        border-radius: 2px;
        font-size: 12px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .mk-dialog-confirm {
    .mk-dialog-confirm-button-loading {
      .circular {
        width: 20px;
        height: 42px;
      }
    }
  }
}
</style>
